import { db } from './index';

function freezeId(habitId, date) {
  return `${habitId}#${date}`;
}

/**
 * Streak-freeze records. Freezes are applied online (a premium, server-verified
 * action), then written locally so the freeze-aware streak math reflects them
 * immediately and after a reload. Pulls reconcile the local set with the server.
 */
export const freezesRepo = {
  async listForHabit(userId, habitId) {
    const rows = await db.freezes
      .where('habitId')
      .equals(habitId)
      .filter((f) => f.userId === userId)
      .toArray();
    return rows.map((f) => f.date).sort();
  },

  async listAllForUser(userId) {
    return db.freezes.where('userId').equals(userId).toArray();
  },

  async put(userId, habitId, date) {
    const id = freezeId(habitId, date);
    await db.freezes.put({ id, habitId, userId, date });
    return { id, habitId, userId, date };
  },

  async clearForUser(userId) {
    await db.freezes.where('userId').equals(userId).delete();
  },

  // Reconcile the local freeze set for a habit against the authoritative server
  // list returned by a pull.
  async replaceServerSetForHabit(userId, habitId, serverDates) {
    const serverSet = new Set(serverDates);
    const local = await db.freezes.where('habitId').equals(habitId).toArray();
    for (const row of local) {
      if (row.userId !== userId) continue;
      if (!serverSet.has(row.date)) await db.freezes.delete(row.id);
    }
    for (const date of serverDates) {
      await this.put(userId, habitId, date);
    }
  },
};
